/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Child_UnlinkInputs */

const fr_guardian_child_unlink = /** @type {(inputs: Guardian_Child_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Délier de ce parent`)
};

/**

* @param {Guardian_Child_UnlinkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_child_unlink = /** @type {((inputs?: Guardian_Child_UnlinkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Child_UnlinkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_child_unlink(inputs)
});